
import { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Button from '../base/Button';

export default function Header() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const navigation = [
    { name: 'Hjem', href: '/' },
    { name: 'Tjenester', href: '/tjenester' },
    { name: 'Aktiviteter', href: '/aktiviteter' },
    { name: 'Om oss', href: '/om-oss' },
    { name: 'Nyhetsbrev', href: '/nyhetsbrev' },
    { name: 'Kontakt', href: '/kontakt' }
  ];

  return (
    <header className="bg-white shadow-sm sticky top-0 z-50">
      <nav className="mx-auto flex items-center justify-between p-4 sm:p-6 lg:px-8">
        <div className="flex lg:flex-1">
          <Link to="/" className="-m-1.5 p-1.5">
            <img 
              src="https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/ca4d10f6f2a4b03e54df831eeeeb8f26.png" 
              alt="Easy Accounting AS" 
              className="h-12 sm:h-14 w-auto"
            />
          </Link>
        </div>
        
        <div className="flex lg:hidden">
          <button
            type="button"
            className="-m-2.5 inline-flex items-center justify-center rounded-md p-2.5 text-gray-700 cursor-pointer"
            onClick={() => setIsMenuOpen(!isMenuOpen)}
          >
            <i className={`ri-${isMenuOpen ? 'close' : 'menu'}-line text-xl sm:text-2xl`}></i>
          </button>
        </div>
        
        <div className="hidden md:flex items-center space-x-8">
          <a href="/" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Hjem
          </a>
          <a href="/tjenester" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Tjenester
          </a>
          <a href="/om-oss" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Om oss
          </a>
          <a href="/aktiviteter" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Aktiviteter
          </a>
          <a href="/nyhetsbrev" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Nyhetsbrev
          </a>
          <a href="/kontakt" className="text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
            Kontakt
          </a>
        </div>
        
        <div className="hidden lg:flex lg:flex-1 lg:justify-end">
          <Link to="/kontakt">
            <Button className="whitespace-nowrap">
              Få tilbud
            </Button>
          </Link>
        </div>
      </nav>
      
      {/* Mobile menu */}
      {isMenuOpen && (
        <div className="lg:hidden">
          <div className="fixed inset-0 z-50 bg-black/20" onClick={() => setIsMenuOpen(false)}></div>
          <div className="fixed inset-y-0 right-0 z-50 w-full overflow-y-auto bg-white px-4 sm:px-6 py-4 sm:py-6 sm:max-w-sm sm:ring-1 sm:ring-gray-900/10">
            <div className="flex items-center justify-between">
              <Link to="/" className="-m-1.5 p-1.5">
                <img 
                  src="https://static.readdy.ai/image/6ed595d4427e0cbb8261bffe6047b408/ca4d10f6f2a4b03e54df831eeeeb8f26.png" 
                  alt="Easy Accounting AS" 
                  className="h-8 sm:h-10 w-auto"
                />
              </Link>
              <button
                type="button"
                className="-m-2.5 rounded-md p-2.5 text-gray-700 cursor-pointer"
                onClick={() => setIsMenuOpen(false)}
              >
                <i className="ri-close-line text-xl sm:text-2xl"></i>
              </button>
            </div>
            <div className="mt-4 sm:mt-6 flow-root">
              <div className="-my-4 sm:-my-6 divide-y divide-gray-500/10">
                <div className="space-y-1">
                  <a href="/" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Hjem
                  </a>
                  <a href="/tjenester" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Tjenester
                  </a>
                  <a href="/om-oss" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Om oss
                  </a>
                  <a href="/aktiviteter" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Aktiviteter
                  </a>
                  <a href="/nyhetsbrev" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Nyhetsbrev
                  </a>
                  <a href="/kontakt" className="block px-3 py-2 text-gray-700 hover:text-blue-600 font-medium cursor-pointer">
                    Kontakt
                  </a>
                </div>
                <div className="py-4 sm:py-6">
                  <Link to="/kontakt" onClick={() => setIsMenuOpen(false)}>
                    <Button className="w-full whitespace-nowrap">
                      Få tilbud
                    </Button>
                  </Link>
                </div>
              </div>
            </div>
          </div>
        </div>
      )}
    </header>
  );
}
